export default function Diagnosis() {
  const checks = [
    "Réglage des gonds et de l'alignement du vantail",
    "Inspection et remplacement de la crémone si usée ou bloquée",
    "Remplacement des joints d'étanchéité déformés ou durcis",
    "Réglage des points de compression et des galets de fermeture",
    "Vérification de la poignée et du carré d'entraînement",
    "Test final d'étanchéité à l'air et à l'eau",
  ];

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Diagnostic complet
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Réglage, joint, mécanisme :{" "}
            <span className="font-serif italic">le diagnostic</span>
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed mb-10">
            <p>
              Quand une fenêtre ne ferme plus bien, le premier réflexe est souvent de forcer la poignée ou de tirer plus fort sur le vantail. C'est exactement ce qu'il ne faut pas faire : vous risquez de casser la crémone, de déformer le carré d'entraînement, ou d'arracher la gâche du dormant. La bonne approche est un diagnostic méthodique, pièce par pièce. Nos techniciens commencent par l'examen visuel : le vantail est-il de niveau ? Les joints sont-ils intacts ? Les points de fermeture s'alignent-ils avec les gâches ?
            </p>
            <p>
              Ils testent ensuite la manœuvre de la fenêtre à chaque étape de l'ouverture, identifiant à quel moment la résistance apparaît. Un frottement en bas indique un gond usé. Un blocage en fin de course suggère une crémone défaillante ou un point de compression mal réglé. Un sifflement d'air révèle un joint à changer. Ce diagnostic complet, qui ne prend que quelques minutes, permet de cibler exactement l'intervention nécessaire — sans remplacer de pièces inutiles et sans laisser un problème latent.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-rose-200 p-6 md:p-8">
            <h3 className="font-semibold text-plum text-base md:text-lg mb-5">
              Ce que nous vérifions lors du diagnostic
            </h3>
            <ul className="space-y-3">
              {checks.map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-coral/10 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-coral text-sm" />
                  </div>
                  <span className="text-sm md:text-base text-plum-dark">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}